import * as ApiClient from '@/libs/ApiClient';
import type { AxiosResponse } from 'axios';
import type { GeneralResp } from '@/models/GeneralResp';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * 手機號碼查詢請求參數
 */
export interface ILoginQueryMobileParams {
    /** 身分證字號或統一編號 */
    ssn: string;
    /** 證券分公司 */
    branchSelect: string;
    /** 生日 (格式: yyyyMMdd) */
    birthday: string;
    /** 驗證碼 (4碼數字) */
    captchaCode: string;
}

/**
 * 手機號碼查詢回應
 */
export interface ILoginQueryMobileResponse extends GeneralResp {
    /** 手機號碼 */
    mobile?: string;
    /** 狀態碼 */
    code?: number;
    /** 文字訊息 */
    letter?: string;
    /** 是否處於等候再次發送區間 */
    isInWaitToSendAgain?: boolean;
    /** 單日發送次數上限 */
    dayLimit?: number;
    /** 當日發送次數 */
    times?: number;
}

/**
 * 登入 - 手機號碼查詢及發送 OTP 簡訊 API
 *
 * @description 根據身分證字號、分公司及生日查詢手機號碼，並發送 OTP 簡訊驗證碼
 * @param params 查詢參數
 * @returns Promise<ILoginQueryMobileResponse>
 */
const LoginQueryMobile = (params: ILoginQueryMobileParams): Promise<ILoginQueryMobileResponse> => {
    const url = RouteUrlList.API_LoginQueryMobile.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };

    return ApiClient.post(
        url,
        {
            ssn: params.ssn,
            branchSelect: params.branchSelect,
            birthday: params.birthday,
            captchaCode: params.captchaCode
        },
        config
    ).then((res: AxiosResponse<ILoginQueryMobileResponse>) => {
        return res.data;
    });
};

export default LoginQueryMobile;
